import React from 'react';
import { useSelector } from 'react-redux';

const AccusedResultsInfo = () => {
    //Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">RESULTADOS IMPUTADOS</h6>
                </div>
                <table className="table table-hover table-sm">
                    <thead className="thead-light">
                        <tr>
                            <th className="text-center">Apellido y Nombre</th>
                            <th className="text-center">Tipo y No. Documento</th>
                            <th className="text-center">Resultados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            audience.imputadoList ? (
                                audience.imputadoList.map(accused => (
                                    <tr key={`ata${accused.id}`}>
                                        <td className="align-middle text-center">
                                            { accused.persona.apellido + ', ' + accused.persona.nombre }
                                        </td>
                                        <td className="align-middle text-center">
                                            {
                                                accused.persona.identificacion ? (
                                                    accused.persona.tipoDocumento + ' ' + accused.persona.identificacion
                                                ) : null
                                            }
                                        </td>
                                        <td className="align-middle text-center">
                                        {
                                            accused.resultado ? (
                                                <table className="table table-striped">
                                                    <tbody>
                                                        <tr>
                                                            <td className="align-middle">Resultado</td>
                                                            <td className="align-middle">
                                                                <strong>{ accused.resultado.descripcion }</strong>
                                                            </td>
                                                        </tr>
                                                        {
                                                            accused.resultadoObs ? (
                                                                <tr>
                                                                    <td className="align-middle">Observaciones</td>
                                                                    <td className="align-middle">
                                                                        <strong>{ accused.resultadoObs }</strong>
                                                                    </td>
                                                                </tr>
                                                            ) : null
                                                        }
                                                        {
                                                            accused.plazo ? (
                                                                <tr>
                                                                    <td className="align-middle">Plazo</td>
                                                                    <td className="align-middle">
                                                                        <strong>{ accused.plazo }</strong>
                                                                    </td>
                                                                </tr>
                                                            ) : null
                                                        }
                                                        {
                                                            accused.modalidad ? (
                                                                <tr>
                                                                    <td className="align-middle">Modalidad</td>
                                                                    <td className="align-middle">
                                                                        <strong>{ accused.modalidad ? accused.modalidad.descripcion : '' }</strong>
                                                                    </td>
                                                                </tr>
                                                            ) : null
                                                        }
                                                    </tbody>
                                                </table>
                                            ) : null
                                        }
                                        </td>
                                    </tr>
                                ))
                            ) : null
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AccusedResultsInfo;